import {useForm} from 'react-hook-form'

import Button from '@mui/material/Button'
import Stack from '@mui/material/Stack'

import FormWrapper from '../../shared/FormWrapper'
import Input from '../../shared/Input'

const ClientForm = props => {
  const methods = useForm({defaultValues: props.data || {}})
  const {errors} = methods.formState

  return (
    <Stack className='invitation'>
      <FormWrapper methods={methods} handleSubmit={props.handleSubmit}>
        <Input
          error={!!errors.name}
          label='Name'
          name='name'
          options={{required: 'Name is required'}}
          helperText={errors.name?.message}
          margin='dense'
        />
        <Input
          error={!!errors.description}
          label='Description'
          name='description'
          options={{required: 'Description is required'}}
          helperText={errors.description?.message}
          type='textarea'
          multiline
          rows={4}
          margin='dense'
        />
        <Input
          error={!!errors.publicKey}
          label='Public KEY'
          name='publicKey'
          options={{required: 'Public Key is required'}}
          helperText={errors.publicKey?.message}
          placeholder='Client public key for request signature verification'
          type='textarea'
          multiline
          rows={10}
          margin='dense'
        />
        <Input
          error={!!errors.webhookUrl}
          label='Webhook URL'
          name='webhookUrl'
          options={{required: 'Webhook URL is required'}}
          placeholder='URL for updating client asynchronously'
          helperText={errors.webhookUrl?.message}
          margin='dense'
        />
        <Input
          label='Redirect URL'
          name='redirectUrl'
          placeholder='URL for redirecting to web client'
          helperText={errors.redirectUrl?.message}
          margin='dense'
        />
        <Input
          label='Resource'
          name='resource'
          placeholder='URL tokens are issued to, for a client that serves as a resource server'
          helperText={errors.resource?.message}
          margin='dense'
        />
        <Button
          disabled={props.loading}
          type='submit'
          variant='contained'
          sx={{color: '#F7F7F7'}}>
          Submit
        </Button>
      </FormWrapper>
    </Stack>
  )
}

export default ClientForm
